import { PageInfoModel } from "../../pipe-pagination/page-info.model";

export class MfgModel {
    mercado: string;
    funcao: string;
    geografia: string;
    pageInfo: PageInfoModel;
}
